import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'
import {queryBearerToken} from "./UserAuthentication";


// **************************************************************************************************************
const fetchBaseArticle = (bearer, articleId) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.BASE_ARTICLE_REQUEST, ActionTypes.BASE_ARTICLE_SUCCESS, ActionTypes.BASE_ARTICLE_FAILURE],
        endpoint: `articles/${articleId}`,
        bearer: bearer,
        schema: Schemas.BASE_ARTICLE,
        method: 'GET',
        payload: {
            articleId
        }
    }
})

export const queryBaseArticle = (articleId) => (dispatch, getState) => {

    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchBaseArticle(getState().token.bearer, articleId))
    })

}

// **************************************************************************************************************
const fetchArticleOptionData = (bearer, articleId) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.ARTICLEOPTION_DATA_REQUEST, ActionTypes.ARTICLEOPTION_DATA_SUCCESS, ActionTypes.ARTICLEOPTION_DATA_FAILURE],
        endpoint: `articles?limit=99&articles=` + (Array.isArray(articleId) ? articleId.join(",") : articleId),
        bearer: bearer,
        schema: Schemas.ARTICLE_OPTION_DATA,
        method: 'GET',
        payload: {
            baseArticleId: articleId
        }
    }
})
const fetchArticleOptionDataSingle = (bearer, articleId) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.ARTICLEOPTION_DATA_REQUEST, ActionTypes.ARTICLEOPTION_DATA_SUCCESS, ActionTypes.ARTICLEOPTION_DATA_FAILURE],
        endpoint: `articles/` + articleId,
        bearer: bearer,
        schema: Schemas.ARTICLE_OPTION_DATA_SINGLE,
        method: 'GET',
        payload: {
            baseArticleId: articleId
        }
    }
})

// single id or array of ids
export const queryArticleOptionData = (articleId) => (dispatch, getState) => {

    if (!articleId || (Array.isArray(articleId) && articleId.length === 0)) {
        return false
    }

    return dispatch(queryBearerToken()).then(() => {
        if (!Array.isArray(articleId) || (Array.isArray(articleId) && articleId.length === 1)) {
            return dispatch(fetchArticleOptionDataSingle(getState().token.bearer, articleId))
        } else {
            return dispatch(fetchArticleOptionData(getState().token.bearer, articleId))
        }
    })

}



/** WEBPACK FOOTER **
 ** ./src/actions/ArticleData.js
 **/